export default ($authProvider) => {
    const { API_URL } = SEED_CORE.ENV;

    $authProvider.loginUrl = `${API_URL}user/auth/login`;
    $authProvider.unlinkUrl = `${API_URL}user/auth/unlink`;
};



// WEBPACK FOOTER //
// ./src/app/configs/auth/index.js